import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import addContactIcon from '../images/addContactIcon.svg';
import defaultSongIcon from '../images/defaultSongIcon.svg';
import trashIcon from '../images/trashIcon.svg';
import defaultSongApplyIcon from '../images/defaultSongApplyIcon.svg';
import PopOver from '../../../../../Shared/Popover/Popover';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../../../Shared/TextInput/TextInput';
import RemoveSong from '../../RemoveSong/RemoveSong';
import {validateHandler,clearIsValid,clearPhone,blurHandler,changeHandler, setPopOverOpenId, setDefaultSong , addContact, setStripMassage, setShuffle} from '../../../fundialSlice';

const OptionsPopOver = (props) => {
    const [isClickAddContact, setIsClickAddContact] = useState(false);
    const [showRemoveSongPopUp, setShowRemoveSongPopUp] = useState(false);
    const songId = props.audio.id;

    function toggleAddContactBtn(){
        setIsClickAddContact(!isClickAddContact);
    }

    async function toggleDefaultSong(){
        setIsClickAddContact(false);
        if(props.isDefaultSong){
            let result = await props.setShuffle({subscriber: props.subscriber.cli , profileId: "" , isSetShuffle: true });
            if(result.payload.errorCode == 0 ){
                props.setPopOverOpenId(null)
            }
        }
        else{
            let result = await props.setDefaultSong({subscriber: props.subscriber.cli , productId: songId });
            if(result.payload.errorCode == 0 ){
                props.setStripMassage({isShow: true , isErrorMsg: false ,message : "הפעולה בוצעה בהצלחה"});
                props.setPopOverOpenId(null)
            }
            else{
                props.setStripMassage({isShow: true , isErrorMsg: true ,message : "הפעולה לא הצליחה"}); 
            }
        }
    }

    async function addContact(phoneInputId){
        setIsClickAddContact(false);
        const phone = props.form.phones[phoneInputId].value;
        if(phone == props.subscriber.cli){
            props.setStripMassage({isShow:true , isErrorMsg: true , message: "הפעולה לא הצליחה" });
        }
        else{
            var result = await  props.addContact({subscriber : props.subscriber.cli , songId: songId , phoneNumbers: [phone]});
            if(result.payload.errorCode == 0){
                props.setStripMassage({isShow: true , isErrorMsg: false ,  message : "הפעולה בוצעה בהצלחה"});
                props.clearPhone(phoneInputId);
                props.setPopOverOpenId(null)
            }
            else if(result.payload.errorCode != 0 ){
                props.setStripMassage({isShow: true , isErrorMsg: true ,message : "הפעולה לא הצליחה"});
            }
        }
    }

    function deleteSong(){
        props.setPopOverOpenId(null)
        setIsClickAddContact(false);
        setShowRemoveSongPopUp(true);
    }

    return (
        <>
        <PopOver
        className='fundial-song-options-popover'
        placement='right'
        text={
            <div>
                <button onClick={() => {deleteSong()}} className="option-btn">
                    <Image src={trashIcon} />
                    <span>מחק</span>
                </button>
                <span className="separator"></span>
                <button onClick={() => {toggleAddContactBtn()}} className="option-btn">
                    <Image src={addContactIcon} />
                    <span>הוסף איש קשר</span>
                </button>
                <span className="separator"></span>
                <button onClick={()=> {toggleDefaultSong()}} className="option-btn" style={{color: props.isDefaultSong? "#e30287" : "black"}}>
                    <Image src={props.isDefaultSong ? defaultSongApplyIcon : defaultSongIcon} />
                    <span>שיר ברירת מחדל</span>
                </button>
                { isClickAddContact && 
                    <div className="wrapper-form-add-contact">
                        <TextInput
                        className='phone-input'
                        name={'phone-'+songId}
                        type='number'
                        pattern='[0-9]*'
                        id={'phone-'+songId}
                        maxLength='10'
                        autoComplete='off'
                        placeholder={'מספר טלפון של איש קשר'}
                        required='required'
                        value={props.form.phones['phone-'+songId].value}
                        error={props.form.multipleErrors['phone-'+songId]}
                        onBlur={(e) => props.blurHandler({target: e.target, form: props.form})}
                        onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                        onWheel={(e) => e.target.blur()}
                        />
                        <div className="btn-wrapper">
                            <BtnSubmit onclick={() => {addContact('phone-'+songId)}} text="הוסף איש קשר" formid="fundial-add-contact"></BtnSubmit>
                        </div>
                    </div> 
                }
            </div>
        }
        target={props.target}
        isOpen={props.popOverOpenId == songId }
        closePopover={(e) => props.setPopOverOpenId(null)}
        />
        <RemoveSong show={showRemoveSongPopUp} close={()=> {setShowRemoveSongPopUp(false)}} audio={props.audio} isDefaultSong={props.isDefaultSong}></RemoveSong>
        </>
    ) ;
}

const mapStateToProps = (state) => {
    return {
        form: state.fundialPage.form,
        popOverOpenId: state.fundialPage.popOverOpenId,
        subscriber: state.fundialPage.selectedSubscriber,
        subscriberGallery: state.fundialPage.subscriberGallery
    };
  };
  
  const mapDispatchToProps = {
    validateHandler,
    clearIsValid,
    clearPhone,
    blurHandler,
    changeHandler,
    setPopOverOpenId,
    setDefaultSong,
    addContact,
    setStripMassage,
    setShuffle
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(OptionsPopOver);







